/* Decorate legacy description layout only; never edit commerce data or copy. */
(() => {
  const selector = '.product__description,.cmx-description,.vhf2-description,.blx3-clean-details,[data-dc-description],.dentcore-exocad-plan-description';
  function prepare(root) {
    root.classList.add('dc-description');
    // Imported document styles must not change the storefront body or header.
    for (const style of root.querySelectorAll('style:not([data-dc-scoped])')) {
      const scope = rules => {
        for (const rule of rules) {
          if (rule.type === CSSRule.STYLE_RULE) {
            rule.selectorText = rule.selectorText.replace(/(^|,)\s*(?:html\s+body|html|body|:root)(?=\s|,|$)/g, '$1 .dc-description');
          } else if (rule.cssRules && rule.type !== CSSRule.KEYFRAMES_RULE) scope(rule.cssRules);
        }
      };
      if (style.sheet) { scope(style.sheet.cssRules); style.dataset.dcScoped = 'true'; }
    }
    for (const el of root.querySelectorAll('[style]')) {
      if (el.closest('form,video,svg')) continue;
      // Imported editors used 650/700/800 for the same emphasis role.
      const weight = el.style.fontWeight;
      if (weight === 'bold' || weight === 'bolder' || Number(weight) >= 600) el.classList.add('dc-copy-semibold');
      if (el.style.display === 'grid') el.classList.add('dc-copy-inline-grid');
      if (el.style.display === 'flex' && !el.matches('a,button')) el.classList.add('dc-copy-inline-flex');
      if (/^(DIV|SECTION|ARTICLE|P|UL|OL|DL)$/.test(el.tagName)) {
        if (el.style.width || el.style.minWidth) el.classList.add('dc-copy-fluid');
        if (el.style.height && el.querySelector('p,h2,h3')) el.classList.add('dc-copy-auto-height');
      }
    }
    // Empty editor spacer paragraphs must not create unmatched tile whitespace.
    for (const p of root.querySelectorAll('p')) {
      const empty = !p.textContent.replace(/[\s\u00a0\u200b]/g, '') &&
        !p.querySelector('img,video,iframe,svg,input,button,audio,canvas,object');
      p.classList.toggle('dc-copy-empty', empty);
    }
    for (const list of root.querySelectorAll('ul,ol')) {
      const style = getComputedStyle(list);
      if (style.display === 'grid' && style.listStyleType === 'none') list.classList.add('dc-copy-tile-list');
    }
    for (const summary of root.querySelectorAll('details > summary')) {
      if (summary.querySelector('.dc-copy-faq-icon')) continue;
      const icon = document.createElement('span');
      icon.className = 'dc-copy-faq-icon';
      icon.setAttribute('aria-hidden', 'true');
      // Lucide Plus (ISC); hide its vertical stroke for the open/minus state.
      icon.innerHTML = '<svg class="lucide lucide-plus" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14"/><path class="dc-copy-faq-vertical" d="M12 5v14"/></svg>';
      summary.append(icon);
    }
    for (const table of root.querySelectorAll('table')) {
      const rows = [...table.rows];
      if (rows.length > 1 && rows.every(row => row.cells.length === 2 && [...row.cells].every(cell => cell.colSpan === 1)) &&
          !table.querySelector('img,video,iframe,button,input,select')) table.classList.add('dc-copy-spec-table');
      if (!table.parentElement.classList.contains('dc-copy-table')) {
        const wrapper = document.createElement('div');
        wrapper.className = 'dc-copy-table';
        wrapper.tabIndex = 0;
        wrapper.setAttribute('role','region');
        wrapper.setAttribute('aria-label', 'Product specifications');
        table.before(wrapper);
        wrapper.append(table);
      }
    }
    for (const link of root.querySelectorAll('a[href^="mailto:"]')) {
      const panel = link.parentElement;
      if (panel.matches('div[style]') && panel.querySelectorAll(':scope > p').length >= 2 &&
          (panel.style.background || panel.style.backgroundColor) && !panel.querySelector('img,video,form')) {
        panel.classList.add('dc-copy-support');
      }
    }
  }
  function scan(node) {
    if (!(node instanceof Element)) return;
    if (node.matches(selector)) prepare(node);
    node.querySelectorAll(selector).forEach(prepare);
  }
  scan(document.documentElement);
  document.addEventListener('shopify:section:load', event => scan(event.target));
  const main = document.querySelector('main');
  if (main) new MutationObserver(records => {
    for (const record of records) for (const node of record.addedNodes) {
      if (node instanceof Element && !node.closest('.dc-description')) scan(node);
    }
  }).observe(main, {childList:true,subtree:true});
})();
